import React, {useEffect, useState } from "react";
import "./styles.css";
import { makeSelectSimCountNewAndTransfer,makeSelectEnableSimCountNextButton } from "ducks/selectors";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { setData } from "ducks/actions";
import { useDispatch } from "react-redux";
import { makeSelectEnableThingsToKnowSection, makeSelectIsSimTypeEsim } from "ducks/selectors/planService";
import { ENTERPRISE_AUTOMATED } from "utils/constants";
import FormattedMessage from "components/FormattedMessage/index";

const AddSims = ({
  simCounts,
  enableThingsToKnow
}) => {
  const dispatch = useDispatch();
  const { newSimCount, transferSimCount,  } = simCounts
  const [newNumbers, setNewNumbers] = useState(newSimCount || 0);
  const [transferNumbers, setTransferNumbers] = useState(
    transferSimCount || 0
  );

  useEffect(() => {
    setNewNumbers(newSimCount || 0);
    setTransferNumbers(transferSimCount || 0);
  }, [newSimCount, transferSimCount]);

  const total = newNumbers + transferNumbers;
  const MAX_SIMS = 10;

  useEffect(() =>{
    if(total === 0) {
      dispatch(
        setData({
          key: "enableThingsToKnow",
          data: {
            enableThingsToKnow: false
          }
        })
      );
       dispatch(
        setData({
          key: "enableSimCountNextBtn",
          data: {
            enableSimCountNextBtn: false
          }
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[total])

  const updateSimCounts = (newCount, transferCount) => {
    if(total < 1){
      dispatch(
        setData({
          key: "enableThingsToKnow",
          data: {
            enableThingsToKnow: false
          }
        })
      );
    }
    dispatch(
      setData({
        key: "simCount",
        data: {
          newSimCount: newCount,
          transferSimCount: transferCount,
          totalSimCount: newCount + transferCount
        }
      })
    );
  };

  const increaseNewNumber = () => {
    if (total < MAX_SIMS) {
      const newCount = newNumbers + 1;

      setNewNumbers(newCount);
      updateSimCounts(newCount, transferNumbers);
    }
  };

  const decreaseNewNumber = () => {
    if (newNumbers > 0) {
      const newCount = newNumbers - 1;

      setNewNumbers(newCount);
      updateSimCounts(newCount, transferNumbers);
    }
  };

  const increaseTransferNumber = () => {
    if (total < MAX_SIMS) {
      const transferCount = transferNumbers + 1;

      setTransferNumbers(transferCount);
      updateSimCounts(newNumbers, transferCount);
    }
  };

  const decreaseTransferNumber = () => {
    if (transferNumbers > 0) {
      const transferCount = transferNumbers - 1;

      setTransferNumbers(transferCount);
      updateSimCounts(newNumbers, transferCount);
    }
  };

  const handleNextButtonClick = () => {
    dispatch(
      setData({
        key: "enableThingsToKnow",
        data: {
          enableThingsToKnow: true
        }
      })
    );
  }

  return (
    <div className="add-sims">
      <h1>Add SIMs to your order</h1>

      <p className="subtitle">Up to 10 SIMs only.</p>

      <div className="total-section">
        <div className="total-label">Total selected</div>
        <div className="total-value">{total} SIMs</div>
      </div>

      <div className="sim-selector">
        {/* Get new number */}
        <div className="sim-row">
          <div className="sim-label">
            <span>Get new number</span>
          </div>

          <div className="counter">
            <button
              className="counter-button"
              onClick={decreaseNewNumber}
              disabled={newNumbers === 0}
            >
              −
            </button>

            <span className="counter-value">
              {newNumbers}
            </span>

            <button
              className="counter-button"
              onClick={increaseNewNumber}
              disabled={total === MAX_SIMS}
            >
              +
            </button>
          </div>
        </div>

        <div className="divider" />

        {/* Transfer existing number */}
        <div className="sim-row">
          <div className="sim-label">
            Transfer existing number
          </div>

          <div className="counter">
            <button
              className="counter-button"
              onClick={decreaseTransferNumber}
              disabled={transferNumbers === 0}
            >
              −
            </button>

            <span className="counter-value">
              {transferNumbers}
            </span>

            <button
              className="counter-button"
              onClick={increaseTransferNumber}
              disabled={total === MAX_SIMS}
            >
              +
            </button>
          </div>
        </div>
      </div>

      <div className="more-than-ten">
        <div className="banner-icon">
          <img
            src={ENTERPRISE_AUTOMATED.THUMBS_UP_ICON}
            alt="Thumbs up"
          />
        </div>

        <FormattedMessage html id="ent_add_sim_bottom_description" defaultMessage="" />
      </div>

      {!enableThingsToKnow ? (
        <button 
          className="got-it-btn" 
          onClick={handleNextButtonClick}
          disabled={total < 1}
        >
          Next
        </button>
      ): null}
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  simCounts: makeSelectSimCountNewAndTransfer(),
  enableSimCountNextBtn: makeSelectEnableSimCountNextButton(),
  isSimTypeEsim: makeSelectIsSimTypeEsim(),
  enableThingsToKnow: makeSelectEnableThingsToKnowSection()
});

export default connect(mapStateToProps)(AddSims);